import { Sparkles } from "lucide-react";

export default function EmBreve({ titulo }) {
  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="em-breve-page">
      <div className="text-center max-w-md">
        <div className="mx-auto w-12 h-12 rounded-md border border-border bg-card flex items-center justify-center mb-4">
          <Sparkles className="w-5 h-5 text-primary" />
        </div>
        <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground mb-1">Fase 2</div>
        <h1 className="font-display text-3xl font-bold tracking-tight">{titulo}</h1>
        <p className="text-sm text-muted-foreground mt-2">
          Em breve. Esta seção fará parte da próxima entrega do AAB Repairs Management System.
        </p>
      </div>
    </div>
  );
}
